import { useCallback, useEffect, useRef, useState } from 'react'

/** Copies text to the clipboard and reports it for two seconds, so a button can confirm itself. */
export function useCopy(): readonly [boolean, (text: string) => void] {
  const [copied, setCopied] = useState(false)
  const timer = useRef<number>(undefined)

  useEffect(() => () => window.clearTimeout(timer.current), [])

  const copy = useCallback((text: string) => {
    void navigator.clipboard?.writeText(text).then(
      () => {
        setCopied(true)
        window.clearTimeout(timer.current)
        timer.current = window.setTimeout(() => setCopied(false), 2000)
      },
      () => setCopied(false),
    )
  }, [])

  return [copied, copy] as const
}
